import { FC } from 'react';
import { PreventTheftSettings } from './PreventTheftSettings/PreventTheftSetting';

export const PreventTheftSettingsPage: FC = () => {
  return <PreventTheftSettings />;
};
